export default __webpack_public_path__ + "static/media/module1-page.c696a2e6.png";